import {
  AuthedWebviewModal,
  FullScreenContainer,
  SlideData,
  WalkthroughLayout,
} from '@highmark-web/highmark-common';
import { Box } from '@leagueplatform/genesis-core';
import account from 'assets/walkthrough-slides/complete-account.png';
import logo from 'assets/bcbswy-logo.svg';
import { useGetWalkthroughSlideContent } from './use-get-walkthrough-slide-content.hook';

export const WalkthroughContainer = ({
  onCompleteWalkthrough,
}: {
  onCompleteWalkthrough: () => void;
}) => {
  const slideData: SlideData = useGetWalkthroughSlideContent();

  return (
    <FullScreenContainer backgroundColor="surface.background.primary">
      <Box>
        <WalkthroughLayout
          slideData={slideData}
          numberOfSlides={6}
          logo={logo}
          formImage={account}
          hasBrandSlide={false}
          onCompleteWalkthrough={onCompleteWalkthrough}
        />
      </Box>
      <AuthedWebviewModal />
    </FullScreenContainer>
  );
};
